import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tx from './Tx';
import {colors} from '../maps/colors';
import {useNavigate, useLocation} from 'react-router-dom';
// import styled from "styled-components";

// const MenuTextStyled = styled.div`
//     font-size: 10px;
//     position: absolute;
//     bottom: -2px;
// `;

function SideMenu(props) {
    const navigate = useNavigate();
    const location = useLocation();

    const {pathname, search} = location;

    const onMenuItemClick = menuItem => {
        if (menuItem.action) {
            menuItem.action();
        } else {
            navigate(`/${menuItem.route}`);
        }
    };

    const currentPath = `${pathname}${search}`;

    return (
        <List>
            {props.data.map((menuItem, idx) => {
                const menuColor = menuItem.routeColor || colors.GREEN;
                const isSelected = `/${menuItem.route}` === currentPath;

                return (
                    <ListItemButton onClick={() => onMenuItemClick(menuItem)} key={idx}
                                    sx={{
                                        minHeight: 48,
                                        justifyContent: props.open ? 'initial' : 'center',
                                        px: 2.5,
                                    }}
                                    selected={isSelected}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: props.open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <menuItem.icon style={{color: menuColor}}/>
                            {/* <MenuTextStyled>
                                <Tx style={{color: menuColor}}>{menuItem.i18nKey}</Tx>
                            </MenuTextStyled> */}
                        </ListItemIcon>
                        <ListItemText
                            primary={<Tx style={{color: menuColor, fontWeight: 500}}>{menuItem.i18nKey}</Tx>}
                            sx={{opacity: props.open ? 1 : 0}}/>
                    </ListItemButton>
                );
            })
            }

        </List>
    );
}

export default SideMenu;